.header {
  display: flex;
  align-items: center;
  padding: 10px var(--pad) 2px;
}

.logo {
  /* Высота задаётся, ширина следует пропорции: логотип не должен
     растягиваться при смене файла на другой по размеру. */
  height: 34px;
  width: auto;
}
